import { render } from "./StudentMain.vue?vue&type=template&id=64095568&scoped=true&ts=true"
import script from "./StudentMain.vue?vue&type=script&lang=ts"
export * from "./StudentMain.vue?vue&type=script&lang=ts"

import "./StudentMain.vue?vue&type=style&index=0&id=64095568&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64095568"]])

export default __exports__